__turbopack_context__.v({
  "activity-icon-wrapper": "styles-module__nsav0W__activity-icon-wrapper",
  "activity-item": "styles-module__nsav0W__activity-item",
  "activity-item-wrapper": "styles-module__nsav0W__activity-item-wrapper",
  "arrow-wrapper": "styles-module__nsav0W__arrow-wrapper",
  "avatar-responsive-wrapper": "styles-module__nsav0W__avatar-responsive-wrapper",
  "block-center": "styles-module__nsav0W__block-center",
  "border": "styles-module__nsav0W__border",
  "column": "styles-module__nsav0W__column",
  "column-align-center": "styles-module__nsav0W__column-align-center",
  "column-align-center-margin": "styles-module__nsav0W__column-align-center-margin",
  "column-center": "styles-module__nsav0W__column-center",
  "column-reverse": "styles-module__nsav0W__column-reverse",
  "column-space-around": "styles-module__nsav0W__column-space-around",
  "content-max-width": "styles-module__nsav0W__content-max-width",
  "content-wrapper-responsive": "styles-module__nsav0W__content-wrapper-responsive",
  "dashed-border": "styles-module__nsav0W__dashed-border",
  "divider": "styles-module__nsav0W__divider",
  "divider-light": "styles-module__nsav0W__divider-light",
  "facebook-button": "styles-module__nsav0W__facebook-button",
  "field-wrapper": "styles-module__nsav0W__field-wrapper",
  "fieldset": "styles-module__nsav0W__fieldset",
  "filter-wrapper": "styles-module__nsav0W__filter-wrapper",
  "fitbit-button": "styles-module__nsav0W__fitbit-button",
  "form-actions": "styles-module__nsav0W__form-actions",
  "form-field-wrapper": "styles-module__nsav0W__form-field-wrapper",
  "form-wrapper": "styles-module__nsav0W__form-wrapper",
  "header-group": "styles-module__nsav0W__header-group",
  "header-image": "styles-module__nsav0W__header-image",
  "heading-multi-line-ellipsis": "styles-module__nsav0W__heading-multi-line-ellipsis",
  "list": "styles-module__nsav0W__list",
  "member-list": "styles-module__nsav0W__member-list",
  "multi-line-ellipsis": "styles-module__nsav0W__multi-line-ellipsis",
  "pulse": "styles-module__nsav0W__pulse",
  "row": "styles-module__nsav0W__row",
  "row-align-center": "styles-module__nsav0W__row-align-center",
  "row-aligned": "styles-module__nsav0W__row-aligned",
  "row-bottom": "styles-module__nsav0W__row-bottom",
  "row-center": "styles-module__nsav0W__row-center",
  "row-center-mobile": "styles-module__nsav0W__row-center-mobile",
  "row-end": "styles-module__nsav0W__row-end",
  "row-responsive": "styles-module__nsav0W__row-responsive",
  "row-space-around": "styles-module__nsav0W__row-space-around",
  "row-space-between-wrapped": "styles-module__nsav0W__row-space-between-wrapped",
  "row-stretch": "styles-module__nsav0W__row-stretch",
  "row-stretch-full-width-break-point": "styles-module__nsav0W__row-stretch-full-width-break-point",
  "row-wrap": "styles-module__nsav0W__row-wrap",
  "row-wrap-centered": "styles-module__nsav0W__row-wrap-centered",
  "row-wrap-space-around": "styles-module__nsav0W__row-wrap-space-around",
  "single-line-ellipsis": "styles-module__nsav0W__single-line-ellipsis",
  "strava-button": "styles-module__nsav0W__strava-button",
  "tab-button": "styles-module__nsav0W__tab-button",
  "tab-row": "styles-module__nsav0W__tab-row",
  "top-border": "styles-module__nsav0W__top-border",
  "top-border-chunky": "styles-module__nsav0W__top-border-chunky",
});
